import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const BRAND = { navy: "#062b6c", green: "#00ad0f" };

const Testimonies = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 550,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 7000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          dots: true,
          infinite: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <section className="relative overflow-hidden bg-[#062b6c] py-16">
      {/* subtle grid + glows */}
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute -left-24 top-0 h-56 w-56 rounded-full bg-[#00ad0f]/18 blur-3xl" />
        <div className="absolute right-[-40px] bottom-[-40px] h-64 w-64 rounded-full bg-[#062b6c]/35 blur-3xl" />
        <div className="absolute inset-0 opacity-[0.08] [background-image:linear-gradient(to_right,#101827_1px,transparent_1px),linear-gradient(to_bottom,#101827_1px,transparent_1px)] [background-size:44px_44px]" />
      </div>

      <div className="container relative mx-auto px-5">
        {/* header */}
        <div className="mb-10 flex flex-col items-center gap-3 text-center text-white md:mb-12">
          <span className="inline-flex items-center gap-2 rounded-full border border-[#00ad0f]/40 bg-[#062b6c]/50 px-4 py-1 text-[11px] font-semibold uppercase tracking-[0.26em] text-[#e4ffe9]">
            <span
              className="h-2 w-2 rounded-full shadow-[0_0_10px_rgba(0,173,15,0.9)]"
              style={{ background: BRAND.green }}
            />
            Client & Trainee Voices
          </span>
          <h1 className="text-2xl font-semibold md:text-3xl">
            What People Say About{" "}
            <span className="bg-gradient-to-r from-[#00ad0f] to-[#7fffb0] bg-clip-text text-transparent">
              Scaftech
            </span>
          </h1>
          <p className="max-w-2xl text-sm leading-relaxed text-slate-300 md:text-base">
            Feedback from organizations and professionals who have trusted us
            with their assets, operations, and competency development.
          </p>
        </div>

        <Slider {...settings}>
          {/* 1 */}
          <div className="px-2 md:px-3">
            <div className="flex min-h-[280px] flex-col justify-between rounded-3xl border border-white/10 bg-[#050b18]/95 p-7 text-slate-100 shadow-[0_20px_60px_rgba(0,0,0,0.7)]">
              <div>
                {/* quote icon */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  className="mb-4 h-6 w-6 text-[#00ad0f]"
                  viewBox="0 0 975.036 975.036"
                >
                  <path d="M925.036 57.197h-304c-27.6 0-50 22.4-50 50v304c0 27.601 22.4 50 50 50h145.5c-1.9 79.601-20.4 143.3-55.4 191.2-27.6 37.8-69.399 69.1-125.3 93.8-25.7 11.3-36.8 41.7-24.8 67.101l36 76c11.6 24.399 40.3 35.1 65.1 24.399 66.2-28.6 122.101-64.8 167.7-108.8 55.601-53.7 93.7-114.3 114.3-181.9 20.601-67.6 30.9-159.8 30.9-276.8v-239c0-27.599-22.401-50-50-50zM106.036 913.497c65.4-28.5 121-64.699 166.9-108.6 56.1-53.7 94.4-114.1 115-181.2 20.6-67.1 30.899-159.6 30.899-277.5v-239c0-27.6-22.399-50-50-50h-304c-27.6 0-50 22.4-50 50v304c0 27.601 22.4 50 50 50h145.5c-1.9 79.601-20.4 143.3-55.4 191.2-27.6 37.8-69.4 69.1-125.3 93.8-25.7 11.3-36.8 41.7-24.8 67.101l35.9 75.8c11.601 24.399 40.501 35.2 65.301 24.399z" />
                </svg>
                <p className="mb-3 text-sm leading-relaxed text-slate-100">
                  We sincerely appreciate your patience and professionalism in
                  accommodating our numerous scope and plan changes. Your
                  flexibility and commitment to excellence have been truly
                  commendable.
                </p>
                <p className="text-sm leading-relaxed text-slate-200/90">
                  It was a pleasure doing business with you, and we look forward
                  to future collaborations.
                </p>
              </div>

              <div className="mt-6 inline-flex items-center">
                <img
                  alt="testimonial"
                  src="/new_img/john-doe.png"
                  className="h-12 w-12 flex-shrink-0 rounded-full object-cover object-center"
                />
                <span className="ml-4 flex flex-col">
                  <span className="text-sm font-semibold text-white">
                    Victor Okoromadu{" "}
                    <span className="text-[11px] uppercase text-slate-400">
                      {" "}
                      • Quality Control Engineer
                    </span>
                  </span>
                  <span className="text-xs text-slate-300">
                    Moytel Consultants Limited
                  </span>
                </span>
              </div>
            </div>
          </div>

          {/* 2 */}
          <div className="px-2 md:px-3">
            <div className="flex min-h-[280px] flex-col justify-between rounded-3xl border border-white/10 bg-[#050b18]/95 p-7 text-slate-100 shadow-[0_20px_60px_rgba(0,0,0,0.7)]">
              <div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  className="mb-4 h-6 w-6 text-[#00ad0f]"
                  viewBox="0 0 975.036 975.036"
                >
                  <path d="M925.036 57.197h-304c-27.6 0-50 22.4-50 50v304c0 27.601 22.4 50 50 50h145.5c-1.9 79.601-20.4 143.3-55.4 191.2-27.6 37.8-69.399 69.1-125.3 93.8-25.7 11.3-36.8 41.7-24.8 67.101l36 76c11.6 24.399 40.3 35.1 65.1 24.399 66.2-28.6 122.101-64.8 167.7-108.8 55.601-53.7 93.7-114.3 114.3-181.9 20.601-67.6 30.9-159.8 30.9-276.8v-239c0-27.599-22.401-50-50-50zM106.036 913.497c65.4-28.5 121-64.699 166.9-108.6 56.1-53.7 94.4-114.1 115-181.2 20.6-67.1 30.899-159.6 30.899-277.5v-239c0-27.6-22.399-50-50-50h-304c-27.6 0-50 22.4-50 50v304c0 27.601 22.4 50 50 50h145.5c-1.9 79.601-20.4 143.3-55.4 191.2-27.6 37.8-69.4 69.1-125.3 93.8-25.7 11.3-36.8 41.7-24.8 67.101l35.9 75.8c11.601 24.399 40.501 35.2 65.301 24.399z" />
                </svg>
                <p className="mb-6 text-sm leading-relaxed text-slate-100">
                  I recently completed the Overhead Crane Operation Safety
                  Refresher Course with Scaftech Engineering Services and was
                  thoroughly impressed by the depth and quality of the training.
                  The instructors were knowledgeable and approachable, making
                  complex topics easy to understand. The practical exercises
                  were particularly beneficial, allowing me to apply theoretical
                  knowledge in a controlled environment. I highly recommend
                  Scaftech for anyone looking to enhance their safety skills in
                  the engineering field.
                </p>
              </div>

              <div className="mt-6 inline-flex items-center">
                <img
                  alt="testimonial"
                  src="/new_img/john-doe.png"
                  className="h-12 w-12 flex-shrink-0 rounded-full object-cover object-center"
                />
                <span className="ml-4 flex flex-col">
                  <span className="text-sm font-semibold text-white">
                    Bernard Bele Olorunwa
                  </span>
                  <span className="text-xs text-slate-300">Student</span>
                </span>
              </div>
            </div>
          </div>

          {/* 3 */}
          <div className="px-2 md:px-3">
            <div className="flex min-h-[280px] flex-col justify-between rounded-3xl border border-white/10 bg-[#050b18]/95 p-7 text-slate-100 shadow-[0_20px_60px_rgba(0,0,0,0.7)]">
              <div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  className="mb-4 h-6 w-6 text-[#00ad0f]"
                  viewBox="0 0 975.036 975.036"
                >
                  <path d="M925.036 57.197h-304c-27.6 0-50 22.4-50 50v304c0 27.601 22.4 50 50 50h145.5c-1.9 79.601-20.4 143.3-55.4 191.2-27.6 37.8-69.399 69.1-125.3 93.8-25.7 11.3-36.8 41.7-24.8 67.101l36 76c11.6 24.399 40.3 35.1 65.1 24.399 66.2-28.6 122.101-64.8 167.7-108.8 55.601-53.7 93.7-114.3 114.3-181.9 20.601-67.6 30.9-159.8 30.9-276.8v-239c0-27.599-22.401-50-50-50zM106.036 913.497c65.4-28.5 121-64.699 166.9-108.6 56.1-53.7 94.4-114.1 115-181.2 20.6-67.1 30.899-159.6 30.899-277.5v-239c0-27.6-22.399-50-50-50h-304c-27.6 0-50 22.4-50 50v304c0 27.601 22.4 50 50 50h145.5c-1.9 79.601-20.4 143.3-55.4 191.2-27.6 37.8-69.4 69.1-125.3 93.8-25.7 11.3-36.8 41.7-24.8 67.101l35.9 75.8c11.601 24.399 40.501 35.2 65.301 24.399z" />
                </svg>
                <p className="mb-6 text-sm leading-relaxed text-slate-100">
                  The Overhead Crane Operation Safety Refresher Course by
                  Scaftech Engineering Services is a must for any experienced
                  crane operator looking to brush up on their skills. The mix of
                  theoretical knowledge and practical application was perfect. I
                  particularly appreciated the focus on mental alertness and
                  emergency protocols. It's clear that Scaftech prioritizes
                  safety and professionalism. I'll definitely be returning for
                  future training needs.
                </p>
              </div>

              <div className="mt-6 inline-flex items-center">
                <img
                  alt="testimonial"
                  src="/new_img/john-doe.png"
                  className="h-12 w-12 flex-shrink-0 rounded-full object-cover object-center"
                />
                <span className="ml-4 flex flex-col">
                  <span className="text-sm font-semibold text-white">
                    Ayomide Onoja
                  </span>
                  <span className="text-xs text-slate-300">Student</span>
                </span>
              </div>
            </div>
          </div>

          {/* 4 */}
          <div className="px-2 md:px-3">
            <div className="flex min-h-[280px] flex-col justify-between rounded-3xl border border-white/10 bg-[#050b18]/95 p-7 text-slate-100 shadow-[0_20px_60px_rgba(0,0,0,0.7)]">
              <div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  className="mb-4 h-6 w-6 text-[#00ad0f]"
                  viewBox="0 0 975.036 975.036"
                >
                  <path d="M925.036 57.197h-304c-27.6 0-50 22.4-50 50v304c0 27.601 22.4 50 50 50h145.5c-1.9 79.601-20.4 143.3-55.4 191.2-27.6 37.8-69.399 69.1-125.3 93.8-25.7 11.3-36.8 41.7-24.8 67.101l36 76c11.6 24.399 40.3 35.1 65.1 24.399 66.2-28.6 122.101-64.8 167.7-108.8 55.601-53.7 93.7-114.3 114.3-181.9 20.601-67.6 30.9-159.8 30.9-276.8v-239c0-27.599-22.401-50-50-50zM106.036 913.497c65.4-28.5 121-64.699 166.9-108.6 56.1-53.7 94.4-114.1 115-181.2 20.6-67.1 30.899-159.6 30.899-277.5v-239c0-27.6-22.399-50-50-50h-304c-27.6 0-50 22.4-50 50v304c0 27.601 22.4 50 50 50h145.5c-1.9 79.601-20.4 143.3-55.4 191.2-27.6 37.8-69.4 69.1-125.3 93.8-25.7 11.3-36.8 41.7-24.8 67.101l35.9 75.8c11.601 24.399 40.501 35.2 65.301 24.399z" />
                </svg>
                <p className="mb-6 text-sm leading-relaxed text-slate-100">
                  Scaftech Engineering Services delivers professional and
                  insightful training sessions. Their Overhead Crane Operation
                  course was filled with valuable safety insights and best
                  practices. Although I found some sections a bit rushed, the
                  overall quality of the training was outstanding. The
                  instructors were experienced and genuinely interested in our
                  learning. I left the course feeling more prepared and aware of
                  the safety aspects of crane operation.
                </p>
              </div>

              <div className="mt-6 inline-flex items-center">
                <img
                  alt="testimonial"
                  src="/new_img/john-doe.png"
                  className="h-12 w-12 flex-shrink-0 rounded-full object-cover object-center"
                />
                <span className="ml-4 flex flex-col">
                  <span className="text-sm font-semibold text-white">
                    Abayomi Oladipupo
                  </span>
                  <span className="text-xs text-slate-300">Student</span>
                </span>
              </div>
            </div>
          </div>
        </Slider>
      </div>
    </section>
  );
};

export default Testimonies;
